export default "__VITE_ASSET__cbjwGYJQ__"